import { HttpStatusCode, isAxiosError } from "axios";
import { SendToTrackingService } from "@/api/handlers/errors";
import { useApiClient } from "@/hooks/useApiClient";
import useSWRMutation, { type SWRMutationResponse } from "swr/mutation";

/**
 * 地図プロットリクエストを削除するカスタムフック
 * クエリパラメータ形式で複数のIDを送信
 */
export const useDeleteMapPlotRequest = (): SWRMutationResponse<
  void,
  Error,
  string,
  number[]
> => {
  const { apiClient } = useApiClient();
  const url = "/map/plot-request";

  const fetcher = async (
    url: string,
    { arg }: { arg: number[] }
  ): Promise<void> => {
    try {
      // クエリパラメータとしてidを送信
      const params = new URLSearchParams();
      arg.forEach((id) => {
        params.append("id", id.toString());
      });

      const response = await apiClient.delete(`${url}?${params.toString()}`);

      if (
        response.status !== HttpStatusCode.Ok &&
        response.status !== HttpStatusCode.NoContent
      ) {
        throw new Error("削除に失敗しました");
      }
    } catch (error) {
      if (
        isAxiosError(error) &&
        (error.response?.status ?? HttpStatusCode.InternalServerError) >=
          HttpStatusCode.InternalServerError
      ) {
        SendToTrackingService(error);
      }
      throw error;
    }
  };

  return useSWRMutation(url, fetcher, { revalidate: false });
};
